import { TableCell } from '@mui/material';
import { icons } from '@shared/static/icons';
import { formatCardNumber } from '@utils/helpers';
import CopyToClipSensitiveCard from '@shared/ui/messages/CopyToClipSensitiveCard';
import { binsLogo } from '@utils/static';
import { CountryFlag } from '@shared/ui/parts';

export default function CardDetailsCell({ row }) {
  return (
    <TableCell padding="none" className="cardDetailsCell">
      <div className="cardDetailsCell__content">
        <div className="cardDetailsCell__logo">
          <CountryFlag countryCode={binsLogo[row.details?.bank_id]} />
        </div>
        <div>
          <div>
            <CopyToClipSensitiveCard
              cardId={row.id}
              sensitiveDataKey="pan"
              display={formatCardNumber(row.details?.cardNumber)}
            />
          </div>
          <div className="cardDetailsCell__exp">
            <div>
              <CopyToClipSensitiveCard
                cardId={row.id}
                sensitiveDataKey="exp_date"
              />
            </div>
            <div>
              <CopyToClipSensitiveCard
                cardId={row.id}
                sensitiveDataKey="cvv"
                display="CVV"
              />
            </div>
          </div>
        </div>
        <div className="cardDetailsCell__payment">
          {icons[row.details?.paymentMethod]}
        </div>
      </div>
    </TableCell>
  );
}
